import { render, staticRenderFns } from "./servicesList.vue?vue&type=template&id=0c61515a&"
import script from "./servicesList.vue?vue&type=script&lang=js&"
export * from "./servicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports